import { render, staticRenderFns } from "./OpenAccountingDocumentButton.vue?vue&type=template&id=3d9b3a68&scoped=true&"
import script from "./OpenAccountingDocumentButton.vue?vue&type=script&lang=js&"
export * from "./OpenAccountingDocumentButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9b3a68",
  null
  
)

export default component.exports